export const currencys = [
  {
    "img_flag": "https://cdn.ggautopay.com/images/flags/3d/th.png",
    "currency": "THB",
    "supported": true,
    "description": "Thai Baht",
    "game_count": 118
  },
  {
    "img_flag": "https://cdn.ggautopay.com/images/flags/3d/us.png",
    "currency": "USD",
    "supported": true,
    "description": "US Dollar",
    "game_count": 54
  },
  {
    "img_flag": "https://cdn.ggautopay.com/images/flags/3d/kh.png",
    "currency": "KHR",
    "supported": true,
    "description": "Cambodian Riel",
    "game_count": 10
  },
  {
    "img_flag": "https://cdn.ggautopay.com/images/flags/3d/vn.png",
    "currency": "VND",
    "supported": false,
    "description": "Vietnamese Dong",
    "game_count": 0
  },
  {
    "img_flag": "https://cdn.ggautopay.com/images/flags/3d/la.png",
    "currency": "LAK",
    "supported": false,
    "description": "Laotian Kip",
    "game_count": 0
  },
  {
    "img_flag": "https://cdn.ggautopay.com/images/flags/3d/cn.png",
    "currency": "CNY",
    "supported": false,
    "description": "Chinese Yuan",
    "game_count": 0
  },
  {
    "img_flag": "https://cdn.ggautopay.com/images/flags/3d/mm.png",
    "currency": "MMK",
    "supported": false,
    "description": "Myanmar Kyat",
    "game_count": 0
  },
  {
    "img_flag": "https://cdn.ggautopay.com/images/flags/3d/ph.png",
    "currency": "PHP",
    "supported": false,
    "description": "Philippine Peso",
    "game_count": 0
  }
]
